export const getOffset = function (el) {
  const rect = el.getBoundingClientRect();
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY
  };
};
export const hasSomeParentTheClass = function (element, classname) {
  if (element.className.split(' ').indexOf(classname) >= 0) return true;
  return element.parentNode && hasSomeParentTheClass(element.parentNode, classname);
};
export const resetHeight = $elements => {
  $elements.forEach($el => {
    $el.style.height = 'auto';
  });
};
export const maxHeight = function ($elements, resHeight = true) {
  if (!$elements) return;
  if (resHeight) resetHeight($elements);
  const max = Math.max.apply(null, [...$elements].map($el => $el.offsetHeight));
  $elements.forEach($el => {
    $el.style.height = `${max}px`;
  });
};
export const minHeight = function ($elements, resHeight = true) {
  if (!$elements) return;
  if (resHeight) resetHeight($elements);
  const min = Math.min.apply(null, [...$elements].map($el => $el.offsetHeight));
  $elements.forEach($el => {
    $el.style.height = `${min}px`;
  });
};

/**
 * Convert bytes to more proper file size.
 * @param {number} bytes - file size in bites.
 * @param {number} decimals - return file size in number size.
 * @returns {string} File size.
 */
export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  // eslint-disable-next-line no-mixed-operators
  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};
export const createEl = (tag = '', attributes = {}, content = '') => {
  const $el = document.createElement(tag);
  Object.keys(attributes).forEach(attr => {
    $el.setAttribute(attr, attributes[attr]);
  });
  $el.innerHTML = content;
  return $el;
};
export const arrayEquals = (a, b) => Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => val === b[index]);
export const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
export const dispatchEvent = function (element, eventName) {
  if ('createEvent' in document) {
    const event = document.createEvent('HTMLEvents');
    event.initEvent(eventName, false, true);
    element.dispatchEvent(event);
  } else {
    element.fireEvent(eventName);
  }
};
export const getElementPositionInContainer = (element, container) => {
  const elementRect = element.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();
  return {
    left: elementRect.left - containerRect.left + container.scrollLeft,
    top: elementRect.top - containerRect.top + container.scrollTop
  };
};
export const isInViewport = (element, additionalMargin) => {
  const $header = document.querySelector('.header');
  const headerOffsetHeight = $header.offsetHeight;
  const navHeight = headerOffsetHeight + additionalMargin;
  const rect = element.getBoundingClientRect();
  const {
    offsetHeight,
    offsetWidth
  } = element;
  const clientHeight = window.innerHeight || document.documentElement.clientHeight;
  const clientWidth = window.innerWidth || document.documentElement.clientWidth;
  return rect.top >= -offsetHeight + navHeight && rect.left >= -offsetWidth && rect.bottom <= clientHeight + offsetHeight + navHeight && rect.right <= clientWidth + offsetWidth;
};
export const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

/**
 * Get element in dom tree or some element.
 * @param {string} selector - Selector of some element.
 * @param {Document|Element} env - Selector parent element.
 * @returns {Element} The found element.
 */
export const getElement = (selector, env = document) => env.querySelector(selector);

/**
 * Get multiply elements in dom tree or some element.
 * @param {string} selector - Selector of some element.
 * @param {Document|Element} env - Selector parent element.
 * @returns {Array} The found elements.
 */
export const getElements = (selector, env = document) => [...env.querySelectorAll(selector)];

/**
 * Add CSS class to an element.
 * @param {Element} el - The target element.
 * @param {string} className - The CSS class name to add.
 */
export const addClass = (el, className) => el.classList.add(className);

/**
 * Remove CSS class from an element.
 * @param {Element} el - The target element.
 * @param {string} className - The CSS class name to add.
 */
export const removeClass = (el, className) => el.classList.remove(className);

/**
 * Toggle CSS class on an element.
 * @param {Element} el - The target element.
 * @param {string} className - The CSS class name to toggle.
 * @param {boolean}[condition] -
 * If true, adds the class.If false, removes it.If omitted, toggles current state.
 */
export const toggleClass = (el, className, condition) => el.classList.toggle(className, condition);

/**
 * Get cookie value
 * @param {Element} name - The name of cookie.
 */
// eslint-disable-next-line consistent-return
export const getCookie = name => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};
export const formatNumber = number => {
  // n=number.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g| '$1,');
  let n;
  n = number.toFixed(2).replace(/./g, (c, i, a) => i && c !== '.' && (a.length - i) % 3 === 0 ? `|${c}` : c);
  n = n.replace('.', '.');
  n = n.replace('|', '.');
  if (document.documentElement.lang === 'de') {
    n = n.replace('.', ',');
  }
  return n;
};
export const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
};
export const formatDate = startDate => {
  const date = new Date(startDate); // Or your specific Date object

  let day = date.getDate();
  let month = date.getMonth() + 1; // getMonth() returns 0-indexed month
  const year = date.getFullYear();

  // Add leading zero if day or month is a single digit
  if (day < 10) {
    day = `0${day}`;
  }
  if (month < 10) {
    month = `0${month}`;
  }
  const formattedDate = `${day}.${month}.${year}`;
  return formattedDate;
};
export const equalizeHeightsByGroup = (selector, env = document, groupSize = 3) => {
  const elements = getElements(selector);
  if (elements.length === 0) return;
  // Reset heights to 'auto' to ensure accurate recalculation on resize
  resetHeight(elements, env);
  for (let i = 0; i < elements.length; i += groupSize) {
    // const maxHeight = 0;
    const group = [];

    // Collect elements in the current group
    for (let j = 0; j < groupSize && i + j < elements.length; j++) {
      group.push(elements[i + j]);
      maxHeight(group);
    }
  }
};
export const scrollroot = () => {
  if ('scrollingElement' in document) return document.scrollingElement;
  const initial = document.documentElement.scrollTop;
  document.documentElement.scrollTop = initial + 1;
  const updated = document.documentElement.scrollTop;
  document.documentElement.scrollTop = initial;
  return updated > initial ? document.documentElement : document.body;
};